export default __webpack_public_path__ + "static/media/delete.d5f77a2c.svg";